import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Allows opening the Notices admin page, which lists every published notice.
 * Active notices themselves are shown to every signed-in user by the pop-up;
 * this permission only gates the management page.
 */
export const noticesReadPermission = createPermission({
  name: 'neo4j-notices.notices.read',
  attributes: { action: 'read' },
});

/** Allows publishing a notice. */
export const noticesCreatePermission = createPermission({
  name: 'neo4j-notices.notices.create',
  attributes: { action: 'create' },
});

/** Allows editing the title and description of a published notice. */
export const noticesUpdatePermission = createPermission({
  name: 'neo4j-notices.notices.update',
  attributes: { action: 'update' },
});

/** Allows removing a published notice for every user. */
export const noticesDeletePermission = createPermission({
  name: 'neo4j-notices.notices.delete',
  attributes: { action: 'delete' },
});

export const noticesPermissions = [
  noticesReadPermission,
  noticesCreatePermission,
  noticesUpdatePermission,
  noticesDeletePermission,
];
